<template>
  <div class="footer">
    <div class="fwcn center">
      <div class="fwcn-item" v-for="(item, i) in serveList" :key="i">
       <tooltip popper-class="tooltip-popper" placement="bottom" effect="light">
        <div slot="content"><span class="desc" v-html="lang === 'en' ? item.enDesc : item.desc"></span></div>
          <div>
            <img class="icon" :src="require('../../assets/other/fwcn/' + item.icon)" alt="">
          <div :class="{'el-tit': true, 'el-tit-en': lang === 'en'}" v-html="lang === 'en' ? item.enTitle : item.title"></div>
          </div>
       </tooltip>
      </div>
    </div>
    <div class="center">
      <div class="left txt" v-show="lang === 'zh'">
        <p>地址：上海市北外滩临潼路188号</p>
        <p>电话：021-62680166</p>
      </div>
      <div class="left txt" v-show="lang === 'zh'">
        <p>邮箱：contact@jinsinan.com.cn</p>
        <p>邮编：200080</p>
      </div>
      <div class="left-en txt"  v-show="lang === 'en'">
        <p>Add：No.188, Lintong Road, North Bund, Hongkou District, Shanghai</p>
        <p>Tel：021-62680166</p>
      </div>
      <div class="middle txt"  v-show="lang === 'en'">
        <p>Email：contact@jinsinan.com.cn</p>
        <p>Zip：200080</p>
      </div>
      <div class="right">
        <p v-show="lang === 'zh'">
          <span class="txt-align">扫描右侧二维码</span>
          <span class="txt-align">关注GF60公众号</span>
        </p>
        <p v-show="lang === 'en'">
          <span class="txt-align">Scan & Follow Us</span>
        </p>
        <img src="../../assets/code.jpg" alt="">
      </div>
    </div>
    <div class="beian">
      <span>版权所有Copyright@2021-2022 上海金司南金融研究院</span>
      <p>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备2021029743号-2</a >
          <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902103759"
              style="margin: 0 0 0 10px;"
              ><img
                src="http://www.beian.gov.cn/img/new/gongan.png"
                style="margin: 0 2px 0 0; width: 16px; vertical-align: text-bottom"
                alt=""
              />沪公网安备 31010902103759号</a
            >
      </p>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'element-ui'
export default {
  components: {Tooltip},
  name: "Footer",
  data(){
    return {
      serveList: [
        {
          icon: '1.png',
          title: '保密承诺',
          enTitle:'Confidentiality Commitment',
          desc: '研究院严格保守在服务过程中获悉的商业秘密',
          enDesc: 'The Institute shall strictly safeguard all commercial secrets acquired during the provision of services and ensure that such information remains confidential.'
        }, {
          icon: '2.png',
          title: '服务品质',
          enTitle: 'Service Quality',
          desc: '按照行业标准和服务合同的约定，为客户提供高质量、专业的服务',
          enDesc: 'The Institute commits to providing high-quality, professional services to clients in accordance with industry standards and the specific terms outlined in the service contract.'
        }, {
          icon: '3.png',
          title: '服务期限',
          enTitle: 'Service Duration',
          desc: '按照合同约定时间及期限提供服务，涉及服务期限变更的，及时与客户沟通并依法办理相应的变更手续',
          enDesc: 'Services will be rendered in accordance with the timeframes and durations specified in the contract. Any changes to the service duration will be promptly communicated to the client, and the necessary amendments will be executed in compliance with applicable laws.'
        }, {
          icon: '4.png',
          title: '服务费用',
          enTitle:'Service Fees',
          desc: '合同中明确约定项目收费标准和收费方式，中途不得擅自增加收费项目或提高收费标准',
          enDesc: 'The fee structure and payment terms are explicitly defined in the contract. There shall be no unauthorized additions to the fee structure or increases in the fee rates during the course of service provision.'
        }, {
          icon: '5.png',
          title: '服务内容',
          enTitle: 'Service Content',
          desc: '按照合同约定提供完整的服务内容，不得降低服务标准',
          enDesc:'The Institute shall deliver the complete scope of services as specified in the contract, ensuring that the service standards are not compromised or reduced.'
        }, {
          icon: '6.png',
          title: '及时沟通',
          enTitle: 'Timely <br>Communication',
          desc: '与客户保持及时有效的沟通，随时解答客户的问题，及时关注客户的需求',
          enDesc: 'The Institute will maintain timely and effective communication with clients, promptly addressing their inquiries and attentively responding to their needs.'
        }, {
          icon: '7.png',
          title: '合作诚信',
          enTitle:'Cooperation and Integrity',
          desc: '以诚信为本，与客户保持良好的合作关系，真诚为客户提供服务',
          enDesc: 'The Institute shall uphold principles of integrity, fostering a positive cooperative relationship with clients and sincerely delivering services in good faith.'
        }]
    }
  },
  computed: {
    lang() {
      return this.$store.state.plang;
    }
  }
}
</script>

<style lang="less">

.tooltip-popper{
  background-color: #d4d4d4ee !important;
  border: none !important;
  .desc{
    font-size: 14px;
    line-height: 22px;
    display: block;
    max-width: 240px;
    text-align: justify;
  }
  .popper__arrow{
    border-width: 0 !important;
    background-color: #d4d4d4ee !important;
    &::after{
      border-bottom-color: #d4d4d4ee !important;
    }
  }
}
.pc-home {
  .footer {
    .fwcn{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start !important;
      margin-bottom: 46px;
      &-item{
        flex: 1;
        border-right: 1px solid #d4d4d4;
        transition:all 0.3s;
        &:last-child{
          border-right: none;
        }
        &:hover{
          cursor: pointer;
          margin-top: -10px;
        }
        text-align: center;
        .icon{
          width: 54px;
          height: 54px;
        }
        .el-tit{
          font-size: 18px;
          font-weight: bolder;
        }
        .el-tit-en{
          font-weight: normal;
          height: 60px;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }

    position: relative;
    line-height: 30px;
    padding: 46px 0 0;
    background: #eee;
    .center {
      display: flex;
      align-items: center;
      .left {
        width: 60%;
      }

      .left-en{
        width: 80%;
      }

      .middle{
        width: 40%;
      }
      .right {
        width: 40%;
      }
      >div {
        >img {
          width: 112px;
        }
      }
      .right {
        text-align: right;
        >* {
          vertical-align: middle;
        }
        p {
          display: inline-block;
          margin-right: 20px;
          span {
            text-align: center;
            display: block;
          }
        }
      }
    }
    .beian {
      border-top: 1px solid #d1d1d1;
      text-align: center;
      margin-top: 20px;
      padding: 10px 0;
      > * {
        display: block;
        text-align: center;
      }
      span {
        color: #666;
        font-size: 12px;
        margin-right: 10px;
      }
      a {
        text-decoration: none;
        color: #666;
        font-size: 12px;
      }
    }
  }
}
</style>
